import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import "./Busy.scss"

const Busy = (props) => {   
    
    return(
        (props.isBusy)
            ?<div className = "ApiWait">
                <div className = "ApiWaitSpinner">
                    <Spinner animation="border" role="status" />                   
                </div>                
            </div>
            :null
    )
}
export default Busy;
